/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Terms_Warningassistance1Inputs */

const en_welcome_terms_warningassistance1 = /** @type {(inputs: Welcome_Terms_Warningassistance1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you need further assistance, please contact`)
};

/**
* | output |
* | --- |
* | "If you need further assistance, please contact" |
*
* @param {Welcome_Terms_Warningassistance1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_terms_warningassistance1 = /** @type {((inputs?: Welcome_Terms_Warningassistance1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Terms_Warningassistance1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_terms_warningassistance1(inputs)
});
export { welcome_terms_warningassistance1 as "welcome_terms_warningAssistance" }